/**
 * Barre de recherche de l'en-tête (HeaderSearch) et page /search.
 *
 * EQUIPMENT_SEARCH_ENABLED : la vente d'équipements (par une entreprise ou par ASSIGANTO)
 * n'existe pas encore côté backend. À false, l'onglet « Équipements » s'affiche
 * « bientôt disponible » sans aucun appel réseau ; passer à true une fois
 * servics/search/equipmentSearchApi.js branché sur l'endpoint réel.
 */
export const EQUIPMENT_SEARCH_ENABLED = false;

export const SEARCH_TYPES = ['all', 'products', 'jobs', 'equipment'];

/** Suggestions à partir de 2 caractères, après une pause de frappe. */
export const SUGGESTION_MIN_LENGTH = 2;
export const SUGGESTION_DEBOUNCE_MS = 250;
export const SUGGESTION_LIMIT = 6;

/** Taille des pages de résultats ; l'onglet « Tout » montre un aperçu de chaque type. */
export const RESULTS_PAGE_SIZE = 12;
export const PREVIEW_PRODUCTS = 6;
export const PREVIEW_JOBS = 3;
export const PREVIEW_EQUIPMENT = 3;
